import Button from "components/common/Button";
import Colors from "assets/Colors";
import { useTranslation } from "react-i18next";
import CustomSelector from "components/common/Selector";
import { Col, Row } from "antd";
import s from "../../../styles/TopMenu.styles";
import style from "./styles";
import Map from "components/icons/Map";
import Thumbnails from "components/icons/Thumbnails";
import useStores from "graphql/useStores";
import { useMessaging } from "context/MessagingContext";
import { useCallback, useEffect } from "react";
import _ from "lodash";

function TopMenu({
  view,
  setView,
  loading,
  saving,
  currentRoom,
  setCurrentRoom,
  store,
  setStore,
  rooms,
  editing,
  setEditing,
  addRoom,
  editRoom,
  handleCancel,
  handleSave,
  selectShape
}) {
  const { t } = useTranslation();

  const { stores, loading: loading2 } = useStores();

  const { setConfirmMessage } = useMessaging();

  const storesOptions = stores.map((store) => ({
    value: store._id,
    name: store.address1,
  }));


  rooms = rooms.filter((room) => room.storeId === store);

  const room = rooms.find((room) => room._id === currentRoom?._id);

  const getTableName = (room) => {
    if (!room.tables || room.tables.length === 0) {
      return (
        <>
         {`${room.name}`}&nbsp;<style.NoTables>{t("components.Rooms.TopMenu.noTables")}</style.NoTables>
        </>
      );
    }
    return room.name;
  };


  const roomsOptions = rooms.map((room) => ({
    value: room._id,
    name: getTableName(room),
  }));

  const handleAddCurrentRoom = (roomId) => {
    const room = rooms.find((room) => room._id === roomId);
    setCurrentRoom(room);
  };

  const isModified = !_.isEqual(currentRoom, room);

  const onCancelEdit = useCallback(
    () => {
      if (isModified) {
        setConfirmMessage({
          titleAlert: t("components.Rooms.TopMenu.cancel"),
          confirm1:  t("components.Rooms.TopMenu.cancelChanges"),
          onConfirm: () => [handleCancel(), setEditing(false)],
        });

      } else {
        handleCancel(),
        setEditing(false);
      }
    },
    [currentRoom]
  );



  if (stores.length === 1 && !store) {
    setStore(stores[0]._id);
    
  }

  

  useEffect(() => {
    if (rooms.length === 1 && !currentRoom) {
      setCurrentRoom(rooms[0]);
    }
  }, [rooms, setCurrentRoom]);


  const allLoading = loading || loading2;

  return (
    <s.Container
    onClick={() => {
      selectShape(null);
    }}
      style={{
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      <Row
        style={{
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <Col xl={14} style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          <Col>
            <s.SubTitle>
              {t("components.Rooms.TopMenu.fields.store.label")}
            </s.SubTitle>
            <CustomSelector
              loading={allLoading}
              disabled={editing || loading}
              placeholder={t(
                "components.Rooms.TopMenu.fields.store.placeholder"
              )}
              options={storesOptions}
              style={{ width: "190px" }}
              value={store}
              onChange={(value) => {setStore(value), setCurrentRoom(null)}}
            />
          </Col>
          <Col>
            <s.SubTitle>
              {t("components.Rooms.TopMenu.fields.room.label")}
            </s.SubTitle>
            <CustomSelector
              loading={allLoading}
              disabled={editing || loading || roomsOptions.length === 0}
              placeholder={t(
                "components.Rooms.TopMenu.fields.room.placeholder"
              )}
              options={roomsOptions}
              style={{ width: "190px" }}
              value={currentRoom?._id}
              onChange={(value) => handleAddCurrentRoom(value)}
            />
          </Col>
          <Col>
            {
              <s.SubTitle>&nbsp; </s.SubTitle>
            }
            <Button
              disabled={loading || !currentRoom}
              style={{
                background: Colors.background_secondary,
                color: Colors.text_primary,
                width: "none",
                fontWeight: "400",
              }}
              onClick={editRoom}
            >
              {t("components.Rooms.TopMenu.modifyRoom")}
            </Button>
          </Col>
        </Col>

        <style.RightContainer xl={10}>
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "10px",
            }}
          >
            {
              <s.SubTitle>&nbsp; </s.SubTitle>
            }
            <Button
              disabled={!currentRoom || loading}
              type="text"
              style={{
                width: "40px",
                height: "40px",
                border: `0px solid ${Colors.background_dividers}`,
                background: "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => {
                setView("map");
              }}
              icon={
                <Map
                  size="30px"
                  color={
                    view === "map" ? Colors.primary : Colors.background_dividers
                  }
                />
              }
            />
          </Col>
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "10px",
            }}
          >
            {
              <s.SubTitle>&nbsp; </s.SubTitle>
            }
            <Button
              disabled={!currentRoom || loading}
              type="text"
              style={{
                width: "40px",
                height: "40px",
                border: `0px solid ${Colors.background_dividers}`,
                background: "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => setView("icons")}
              icon={
                <Thumbnails
                  size="30px"
                  color={
                    view === "icons"
                      ? Colors.primary
                      : Colors.background_dividers
                  }
                />
              }
            ></Button>
          </Col>

          <Col>
            {
              <s.SubTitle>&nbsp; </s.SubTitle>
            }
            <Button
              disabled={loading || (editing ? !editing : !store)}
              style={{
                background: Colors.background_secondary,
                color: Colors.text_primary,
                width: "none",
                fontWeight: "500",
                height: "40px",
              }}
              onClick={() =>
                editing ? [onCancelEdit()] : addRoom()
              }
            >
              {editing
                ? t("actions.cancel")
                : t("components.Rooms.TopMenu.addRoom")}
            </Button>
          </Col>
          <Col>
            {
              // width > 768 &&
              <s.SubTitle>&nbsp; </s.SubTitle>
            }
            <Button
              disabled={loading || !currentRoom || currentRoom?.virtual}
              loading={saving}
              style={{
                background: Colors.primary,
                color: Colors.text_on_secondary,
                borderColor: Colors.primary,
                width: "130px",
                fontWeight: "500",
                height: "40px",
              }}
              onClick={() => (editing ? handleSave() : setEditing(true))}
            >
              {editing
                ? t("actions.save")
                : t("components.Rooms.TopMenu.editMap")}
            </Button>
          </Col>
        </style.RightContainer>
      </Row>
    </s.Container>
  );
}

export default TopMenu;
